import BrandBranchFilter from 'shared/common/BrandBranchFilter/ui'
import { CheckboxOptions } from 'shared/common/ConvertToCheckboxOptions'

import { SelectQuery } from 'shared/ui/FormQuery/SelectQuery'
import { Spin } from 'shared/ui/Spin'

import { useUsers } from '../hooks/useUsers'

const selectClass = 'w-full min-h-[36px]'
const AccessManageFilter = () => {
  const { roleOptions, isRolesFetching } = useUsers()

  return (
    <div className="flex gap-[12px]">
      <BrandBranchFilter />
      <SelectQuery
        notFoundContent={isRolesFetching ? <Spin size="small" /> : null}
        isLoading={isRolesFetching}
        placeholder="Роль"
        className={selectClass}
        options={CheckboxOptions({ options: roleOptions, paramKey: 'role' })}
        queryKey="role"
      />
    </div>
  )
}

export default AccessManageFilter
